import { TenantMenuApi } from '@wiz-api/eaf-tenant-management'

const tenantMenuApi = new TenantMenuApi()
const router = Wiz.router
const store = Wiz.store
function getFirstPage(treeArr) {
  if (treeArr.children && treeArr.children.length) {
    getFirstPage(treeArr.children[0])
  } else {
    router.push(treeArr.index)
  }
}
export const initRedirect = async (tenantName) => {
  if (tenantName) {
    const allMenus = store.getters['Auth/hasDetailPageMenu'] || []
    const removeArr = _.remove(allMenus, (item) => {
      return item.title === '系统管理'
    })
    if (removeArr && removeArr.length) {
      allMenus.push(removeArr[0])
    }
    const [err, resData] = await tenantMenuApi.getHomeMenu()
    // 未配置跳转404
    if (err || !resData) {
      if (!allMenus.length) {
        router.push('/error/404')
        return
      }
      store.dispatch('Auth/topMenuPath', allMenus[0].index)
      store.dispatch('Auth/selectMenu', allMenus[0].children)
      getFirstPage(allMenus[0])
      // router.push(allMenus[0].children[0].index)
      return
    }
    // 租户登录跳转配置首页路由
    store.dispatch('Auth/topMenuPath', resData.index)
    store.dispatch('Auth/defaultPath', resData.url)
    router.push(resData.url)
    return
  }
  // 运营商登录跳转在线模块
  store.dispatch('Auth/topMenuPath', '在线模块')
  router.push('/host-management/host-online')
}

export const clearUserStorageInfo = (userId) => {
  // 更换登录账户，清除数据缓存
  const userInfo = Wiz.AuthHooks.GetUserInfo()
  if (!userInfo || !userInfo.profile) return
  if (userInfo.profile.sub !== userId) {
    const currentTheme = store.getters['System/currentTheme']
    localStorage.clear()
    const vuexModules = ['Auth', 'System', 'Abp', 'Sites']
    vuexModules.forEach((item) => {
      store.commit(`${item}/resetState`)
    })
    // 退出清空缓存后设置当前主题缓存 保证登录页主题显示正常
    store.dispatch('System/currentTheme', currentTheme)
  }
  // if (
  //   !tenantName ||
  //   (userInfo && userInfo.profile.tenantName !== tenantName) ||
  //   (userInfo && userInfo.profile.name !== userNameOrEmailAddress)
  // ) {
  //   localStorage.clear()
  //   const vuexModules = ['Auth', 'System', 'Abp', 'Sites']
  //   vuexModules.forEach((item) => {
  //     store.commit(`${item}/resetState`)
  //   })
  // }
}

export const setProjectInfo = (projectInfo) => {
  // 缓存设置 icon title logo
  store.dispatch('Auth/projectInfo', projectInfo)
}

export const initRedirectWithoutAuth = () => {
  let allMenus = []
  const menuList = store.getters['Auth/menuList'] || []
  const systemMenuList = store.getters['Auth/systemMenuList'] || []
  allMenus = [...menuList, ...systemMenuList]
  const removeArr = _.remove(allMenus, (item) => {
    return item.title === '系统管理'
  })
  if (removeArr && removeArr.length) {
    allMenus.push(removeArr[0])
  }
  store.dispatch('Auth/topMenuPath', allMenus[0].title)
  store.dispatch('Auth/selectMenu', allMenus[0].children)
  store.dispatch('Auth/defaultPath', Wiz.globalSettings.layout.config.defaultIndex)
  getFirstPage(allMenus[0])
}
